import { colors } from 'modules/app/styles'
import ReactSwitch from 'react-switch'

export function SwitchComponent(props) {
  return (
    <ReactSwitch
      id={props.label}
      onChange={(status) => {
        props?.set_settings((prevSettings) => {
          const data = { ...prevSettings, [props.label]: status }
          props.updateSettings(data)
          return data
        })
      }}
      checked={props.settings[props.label]}
      className={`reactSwitch ${props?.settings[props.label] ? 'on' : 'off'}`}
      offColor='#fff'
      onColor={colors['main-blue']}
      offHandleColor={colors['light-blue-300']}
      onHandleColor='#fff'
      width={48}
      height={24}
      handleDiameter={16}
      uncheckedIcon={false}
      checkedIcon={false}
    />
  )
}
